import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-informacion-util',
  templateUrl: './informacion-util.component.html',
  styleUrls: ['./informacion-util.component.css']
})
export class InformacionUtilComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
